import { nudosGray300 } from '../../../../styles/styles.constants';
import BordOneToneIcon from '../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './SmallQrButton.scss';

const SmallQrButton = ({ getQrCodeCallback, disabled }: { getQrCodeCallback: () => void; disabled: boolean }) => {
  return (
    <div className={`smallQrButton ${disabled ? 'disabled' : ''}`} onClick={disabled ? undefined : getQrCodeCallback}>
      <BordOneToneIcon variant="qr" customWidth="12px" stroke={disabled ? nudosGray300 : 'white'} />
      <span>QR</span>
    </div>
  );
};

export default SmallQrButton;
